import {FormikSelect} from '@flexinet/ui-components';
import {useReportTypes} from '../hooks/useReportTypes';
import {ReportType} from '../types';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';


export const ReportTypesDropdown = (props: FieldProps & SelectProps) => {

    const {items: reportTypes} = useReportTypes();

    const selectOptions = reportTypes.map((item: ReportType) => {
        return {
            value: item.id,
            label: `${item.name || item.id} (v${item.version})`,
        };
    });

    return <FormikSelect {...props} data={selectOptions}/>;
};
